/* A1 Chatbot v3 — FAQ matching + mascot state machine. Vanilla JS, no dependencies.
 * v3: sign-free mascot with arms; after pointing he does a pretend click (tap + glow on the
 * element). Nothing on the page is ever actually clicked.
 * Data:   assets/a1-chatbot-faq.json  (records with "sample": true are hidden on the storefront)
 * Poses:  mascot-idle / mascot-scurry / mascot-point (.webp) — all drawn facing RIGHT.
 * Events: dataLayer chatbot_open | chatbot_question | chatbot_fallback | chatbot_thumbs
 */
(function () {
  'use strict';

  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var REDUCED = mq('(prefers-reduced-motion: reduce)');
  var ROAM_DELAY = 12000;      // ms of inactivity before he wanders (playful mode only)
  var FIRST_ROAM_MS = 8000;    // first stroll comes early so visitors actually see him
  var NUDGE_DELAY = 20000;     // one-time "Questions? Ask me!" per session
  var TRAVEL_MS = 1600;        // must match the CSS transition on .a1-chat-mascot
  var POINT_HOLD = 2800;       // ms he holds a point (includes the pretend click)
  var TAP_AT = 420;            // ms after arriving that he taps the element
  var GLOW_MS = 3200;          // how long the tapped element keeps its glow
  var HAND_Y = 0.39;           // fingertip height as a fraction of the point pose
  var TYPING_MS = 600;
  var THRESHOLD = 0.35;        // min score for a confident answer
  var DISMISS_KEY = 'a1chat_dismissed_v1';
  var NUDGE_KEY = 'a1chat_nudged_v1';
  var HASH_PREFIX = '#a1-point=';
  var APRIL_FOOLS = (function () { var d = new Date(); return d.getMonth() === 3 && d.getDate() === 1; })();
  var PHONE = '443-552-7338';
  var EMAIL = 'a1dentalsupply@gmail.com';

  function isMobile() { return mq('(max-width: 480px)'); }  // checked live, not just at load

  function ss(k, v) { // sessionStorage that never throws (private mode, blocked storage)
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  /* ---------- matching ---------- */
  var STOP = {};
  ('the a an is are do does did you your i my me how what when where which can could of for to in on it its ' +
   'and or we us our with by be at as this that there their they them from about much many not no if any ' +
   'have has had get one will would should want need please hi hello hey there im ive').split(' ')
    .forEach(function (w) { STOP[w] = 1; });

  function tokens(s) {
    return (s || '').toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9\s]/g, ' ').split(/\s+/)
      .filter(function (t) { return t && !STOP[t] && t.length > 1; })
      .map(function (t) { return t.length > 4 ? t.replace(/(ies|es|s)$/, function (m) { return m === 'ies' ? 'y' : ''; }) : t; });
  }

  function scoreFaq(queryTokens, faq) {
    if (!queryTokens.length) return 0;
    var best = 0;
    for (var v = 0; v < faq._qt.length; v++) {
      var vt = faq._qt[v];
      if (!vt.length) continue;
      var hit = 0;
      for (var i = 0; i < vt.length; i++) {
        for (var j = 0; j < queryTokens.length; j++) {
          var a = vt[i], b = queryTokens[j];
          if (a === b) { hit += a.length > 4 ? 2 : 1; break; }
          if (a.length > 3 && b.length > 3 && (a.indexOf(b) === 0 || b.indexOf(a) === 0)) { hit += 1; break; }
        }
      }
      // normalise by the longer of the two so a one-word query can't fully match a long variant
      var s = hit / Math.max(vt.length, Math.min(queryTokens.length, vt.length + 2));
      if (s > best) best = s;
    }
    for (var k = 0; k < faq._tags.length; k++) {
      if (queryTokens.indexOf(faq._tags[k]) !== -1) best += 0.15;
    }
    return best;
  }

  function prepare(list) {
    var showSamples = (window.Shopify && window.Shopify.designMode) || /[?&]a1chat_samples=1/.test(location.search);
    return (Array.isArray(list) ? list : []).filter(function (f) {
      return f && f.id && f.answer && f.questions && f.questions.length && (!f.sample || showSamples);
    }).map(function (f) {
      f._qt = f.questions.map(tokens);
      f._tags = (f.tags || []).map(function (t) { return tokens(t)[0] || t; });
      return f;
    });
  }

  /* ---------- widget ---------- */
  function init() {
    var root = document.getElementById('a1Chat');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    if (ss(DISMISS_KEY)) { root.style.display = 'none'; return; }

    var $ = function (id) { return document.getElementById(id); };
    var POSES;
    try { POSES = window.A1_CHAT_POSES || JSON.parse($('a1ChatPoses').textContent); } catch (e) { POSES = {}; }
    var PLAYFUL = root.getAttribute('data-temperament') === 'playful';
    var faqUrl = root.getAttribute('data-faq-url');

    var mascot = $('a1ChatMascot');
    var mascotImg = $('a1ChatMascotImg');
    var launcher = $('a1ChatLauncher');
    var dismissBtn = $('a1ChatDismiss');
    var bubble = $('a1ChatBubble');
    var panel = $('a1ChatPanel');
    var msgs = $('a1ChatMsgs');
    var chipsBox = $('a1ChatChips');
    var form = $('a1ChatForm');
    var input = $('a1ChatInput');
    var closeBtn = $('a1ChatClose');

    var FAQ = [];
    var state = 'parked'; // parked | roaming | pointing
    var panelOpen = false;
    var roamTimer = null, bubbleTimer = null, seq = 0, pointSeq = 0;
    var greeted = false;
    var pos = { x: 0, y: 0 }; // current translate offset from the parked spot

    // preload poses so the first swap doesn't flash
    Object.keys(POSES).forEach(function (k) { var i = new Image(); i.src = POSES[k]; });

    function setPose(name, faceLeft) {
      var src = POSES[name] || POSES.idle;
      if (src && mascotImg.getAttribute('src') !== src) mascotImg.src = src;
      mascotImg.style.scale = faceLeft ? '-1 1' : '';
      mascot.setAttribute('data-pose', name);
    }

    function parkedRect() {
      // the parked spot is wherever CSS puts the mascot with no translate applied
      var r = mascot.getBoundingClientRect();
      return { x: r.left - pos.x, y: r.top - pos.y, w: r.width, h: r.height };
    }

    function travel(x, y, then) {
      var p = parkedRect();
      var dx = x - p.x, dy = y - p.y;
      var faceLeft = dx < pos.x; // face the direction of travel
      mascot.classList.add('a1chat-moving');
      setPose('scurry', faceLeft);
      pos = { x: dx, y: dy };
      mascot.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      var my = ++seq;
      setTimeout(function () { if (my === seq && then) then(); }, REDUCED ? 0 : TRAVEL_MS);
    }

    function goHome() {
      hideBubble();
      var p = parkedRect();
      travel(p.x, p.y, function () {
        mascot.classList.remove('a1chat-moving');
        mascot.style.transform = '';
        pos = { x: 0, y: 0 };
        setPose('idle');
        state = 'parked';
        scheduleRoam();
      });
    }

    function placeBubble() {
      var r = mascot.getBoundingClientRect();
      bubble.classList.toggle('a1chat-below', r.top < 90);
      var cx = r.left + r.width / 2;
      bubble.classList.toggle('a1chat-align-right', cx > window.innerWidth - 140);
      bubble.classList.toggle('a1chat-align-left', cx < 140);
    }

    function showBubble(text, ms) {
      bubble.textContent = text;
      placeBubble();
      bubble.classList.add('a1chat-show');
      clearTimeout(bubbleTimer);
      bubbleTimer = setTimeout(hideBubble, ms || 3200);
    }
    function hideBubble() { bubble.classList.remove('a1chat-show'); }

    function scheduleRoam() {
      clearTimeout(roamTimer);
      if (!PLAYFUL || REDUCED || isMobile() || panelOpen || state !== 'parked') return;
      roamTimer = setTimeout(roam, ROAM_DELAY);
    }

    function roam() {
      if (!PLAYFUL || panelOpen || state !== 'parked' || REDUCED || isMobile()) return;
      state = 'roaming';
      hideBubble();
      var p = parkedRect();
      // bottom lane only: same y as the parked spot, anywhere across the width
      var destX = 16 + Math.random() * Math.max(40, window.innerWidth - p.w - 32);
      travel(destX, p.y, function () {
        mascot.classList.remove('a1chat-moving');
        setPose('idle');
        showBubble('Psst — questions? Ask me!', 2600);
        setTimeout(function () { if (state === 'roaming') goHome(); }, 2800);
      });
    }

    function findTarget(key) {
      var els = document.querySelectorAll('[data-chat-target="' + key + '"]');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && getComputedStyle(els[i]).visibility !== 'hidden') return els[i];
      }
      return null;
    }

    function canPoint() { return !REDUCED && !isMobile(); }

    // Pretend click: glow + ripple on the element. Never calls el.click().
    function pressTarget(el, cx, cy) {
      el.classList.remove('a1chat-press');
      void el.offsetWidth; // restart the animation if it's already running
      el.classList.add('a1chat-glow', 'a1chat-press');
      clearTimeout(el._a1chatGlow);
      el._a1chatGlow = setTimeout(function () { el.classList.remove('a1chat-glow', 'a1chat-press'); }, GLOW_MS);
      if (cx != null && !REDUCED) {
        var rp = document.createElement('span');
        rp.className = 'a1-chat-ripple';
        rp.style.left = cx + 'px'; rp.style.top = cy + 'px';
        root.appendChild(rp);
        setTimeout(function () { rp.remove(); }, 700);
      }
    }

    function inView(el) {
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
    }

    // Returns true if he is (or will be) pointing at the target on this page.
    function pointAt(targetKey, note) {
      if (!targetKey) return false;
      var el = findTarget(targetKey);
      if (!el) return false;
      if (!canPoint()) {
        if (REDUCED && !isMobile() && inView(el)) pressTarget(el);
        return false;
      }
      clearTimeout(roamTimer);
      hideBubble();
      state = 'pointing';
      var mine = ++pointSeq;
      var r0 = el.getBoundingClientRect();
      var offscreen = r0.top < 0 || r0.bottom > window.innerHeight - 20;
      if (offscreen) {
        try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); }
      }
      setTimeout(function () {
        var r = el.getBoundingClientRect();
        var p = parkedRect();
        var w = p.w, h = p.h, gap = 4;
        var faceLeft = false, x;
        if (r.left - w - gap >= 8) { x = r.left - w - gap; }          // stand left of it, point right
        else { x = r.right + gap; faceLeft = true; }                 // otherwise stand right, point left
        x = Math.max(8, Math.min(x, window.innerWidth - w - 8));
        // line his fingertip up with the target's middle
        var y = Math.max(8, Math.min(r.top + r.height / 2 - h * HAND_Y, window.innerHeight - h - 8));
        travel(x, y, function () {
          mascot.classList.remove('a1chat-moving');
          setPose('point', faceLeft);
          if (note) showBubble(note, POINT_HOLD + 300);
          setTimeout(function () {
            if (state !== 'pointing' || mine !== pointSeq) return;
            mascot.style.setProperty('--a1-dir', faceLeft ? -1 : 1);
            mascot.classList.add('a1chat-tap');
            setTimeout(function () {                      // fingertip meets the element
              var rr = el.getBoundingClientRect();
              pressTarget(el, faceLeft ? rr.right - 6 : rr.left + 6, rr.top + rr.height / 2);
            }, 170);
            setTimeout(function () { mascot.classList.remove('a1chat-tap'); }, 460);
          }, TAP_AT);
          setTimeout(function () { if (state === 'pointing' && mine === pointSeq) goHome(); }, POINT_HOLD);
        });
      }, offscreen ? 650 : 0);
      return true;
    }

    /* ---------- messaging ---------- */
    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function addMsg(html, who) {
      var d = document.createElement('div');
      d.className = 'a1-chat-msg ' + who;
      d.innerHTML = html;
      msgs.appendChild(d);
      msgs.scrollTop = msgs.scrollHeight;
      return d;
    }

    function linksHtml(links) {
      if (!links || !links.length) return '';
      return '<div class="a1-chat-links">' + links.map(function (l) {
        return '<a href="' + esc(l.url) + '"' + (l.faq ? ' data-faq="' + esc(l.faq) + '"' : '') + '>' + esc(l.label) + '</a>';
      }).join('') + '</div>';
    }

    function thumbsHtml() {
      return '<div class="a1-chat-thumbs"><span>Helpful?</span><button type="button" data-t="up" aria-label="Helpful">👍</button>' +
        '<button type="button" data-t="down" aria-label="Not helpful">👎</button></div>';
    }

    function emit(name, detail) {
      try {
        window.dataLayer = window.dataLayer || [];
        var o = { event: name };
        for (var k in detail) if (Object.prototype.hasOwnProperty.call(detail, k)) o[k] = detail[k];
        window.dataLayer.push(o);
      } catch (e) { /* noop */ }
    }

    function bind(node, faqId) {
      node.querySelectorAll('.a1-chat-thumbs button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-t');
          b.parentElement.innerHTML = '<span class="a1chat-thanks">Thanks for the feedback!</span>';
          try {
            var log = JSON.parse(localStorage.getItem('a1chat_thumbs') || '[]');
            log.push({ id: faqId, v: v, t: Date.now() });
            localStorage.setItem('a1chat_thumbs', JSON.stringify(log.slice(-50)));
          } catch (e) { /* private mode */ }
          emit('chatbot_thumbs', { faq_id: faqId, value: v });
        });
      });
      node.querySelectorAll('[data-faq]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var f = byId(a.getAttribute('data-faq'));
          if (f) { addMsg(esc(f.chip || f.questions[0]), 'user'); answer(f, 1); }
        });
      });
    }

    function byId(id) {
      for (var i = 0; i < FAQ.length; i++) if (FAQ[i].id === id) return FAQ[i];
      return null;
    }

    /* Business hours: Mon-Thu 9AM-5PM, Fri 8:30AM-3PM Eastern. Closed weekends. */
    function etNow() {
      try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); }
      catch (e) { return new Date(); }
    }
    function isOpenNow() {
      var et = etNow();
      var day = et.getDay(), mins = et.getHours() * 60 + et.getMinutes();
      if (day === 0 || day === 6) return false;
      if (day === 5) return mins >= 510 && mins < 900;
      return mins >= 540 && mins < 1020;
    }
    function nextOpenStr() {
      var et = etNow();
      var day = et.getDay(), mins = et.getHours() * 60 + et.getMinutes();
      if (day === 0 || day === 6) return 'Monday at 9AM';
      if (day === 5) return mins < 510 ? 'today at 8:30AM' : 'Monday at 9AM';
      if (mins < 540) return 'today at 9AM';
      return day === 4 ? 'tomorrow at 8:30AM' : 'tomorrow at 9AM';
    }

    function answer(f, score) {
      var links = (f.links || []).slice();
      var pointed = false;
      if (f.point_to && f.point_to.target) {
        pointed = pointAt(f.point_to.target, f.point_to.note);
        // target isn't on this page (or he can't move): offer a link that takes them there
        var page = f.point_to.page;
        var already = links.some(function (l) { return l.url === page; });
        if (!pointed && canPoint() && page && page !== location.pathname && !already) {
          links.push({ label: 'Show me', url: page + HASH_PREFIX + encodeURIComponent(f.point_to.target) });
        }
      }
      var bodyHtml = esc(f.answer) + linksHtml(links) + thumbsHtml();
      if (!isOpenNow() && /call( us| a)?|443-552/i.test(f.answer)) {
        bodyHtml = '<div class="a1-chat-hours-note">Heads up \u2014 we\u2019re closed right now. We open ' + esc(nextOpenStr()) + '.</div>' + bodyHtml;
      }
      var node = addMsg(bodyHtml, 'bot');
      bind(node, f.id);
      emit('chatbot_question', { faq_id: f.id, score: Math.round(score * 100) / 100, pointed: pointed });
    }

    function bestMatches(q, n) {
      var qt = tokens(q);
      return FAQ.map(function (f) { return { f: f, s: scoreFaq(qt, f) }; })
        .sort(function (a, b) { return b.s - a.s; })
        .slice(0, n || 3);
    }

    function respond(userText) {
      addMsg(esc(userText), 'user');
      var typing = addMsg('<span class="a1-chat-typing" aria-label="Typing"><span></span><span></span><span></span></span>', 'bot');
      setTimeout(function () {
        typing.remove();
        var top = bestMatches(userText, 3);
        if (top.length && top[0].s >= THRESHOLD) answer(top[0].f, top[0].s);
        else fallback(userText, top);
      }, TYPING_MS);
    }

    /* Product search: when the FAQ doesn't have it, search the product index (SKUs, titles) */
    var PRODUCT_INDEX = null;
    function loadProductIndex(cb) {
      if (PRODUCT_INDEX) { cb(PRODUCT_INDEX); return; }
      var base = document.getElementById('a1Chat').getAttribute('data-product-index-url');
      if (!base || !window.fetch) { cb([]); return; }
      // index is split into 3 chunks: -1.json, -2.json, -3.json
      // strip query string (?v=...) before adding chunk suffix, then re-append
      var qpos = base.indexOf('?');
      var qs = qpos !== -1 ? base.substring(qpos) : '';
      var cleanBase = qpos !== -1 ? base.substring(0, qpos) : base;
      var prefix = cleanBase.replace(/\.json$/, '');
      var urls = [prefix + '-1.json' + qs, prefix + '-2.json' + qs, prefix + '-3.json' + qs];
      var all = [];
      var pending = urls.length;
      urls.forEach(function (u) {
        fetch(u).then(function (r) { return r.json(); }).then(function (d) {
          all = all.concat(d);
          if (--pending === 0) { PRODUCT_INDEX = all; cb(all); }
        }).catch(function () {
          if (--pending === 0) { PRODUCT_INDEX = all; cb(all); }
        });
      });
    }
    function searchProducts(query, done) {
      loadProductIndex(function (idx) {
        if (!idx.length) { done([]); return; }
        var q = query.toLowerCase().replace(/[^a-z0-9]+/g, '');
        var out = [];
        for (var i = 0; i < idx.length && out.length < 4; i++) {
          var p = idx[i];
          var hit = false;
          // check SKUs (exact or partial)
          for (var s = 0; s < p.s.length; s++) {
            var sku = (p.s[s] || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
            if (sku && (sku === q || sku.indexOf(q) === 0 || q.indexOf(sku) === 0)) { hit = true; break; }
          }
          // check title words
          if (!hit) {
            var tw = p.t.toLowerCase().split(/[^a-z0-9]+/);
            var qw = query.toLowerCase().split(/[^a-z0-9]+/);
            for (var a = 0; a < qw.length; a++) {
              if (qw[a].length < 3) continue;
              for (var b = 0; b < tw.length; b++) {
                if (tw[b] === qw[a] || (tw[b].length > 4 && qw[a].length > 4 && tw[b].indexOf(qw[a]) === 0)) { hit = true; break; }
              }
              if (hit) break;
            }
          }
          if (hit) out.push({ label: p.t, url: p.u });
        }
        done(out);
      });
    }

    function fallback(userText, top) {
      // First: try the product catalog (part numbers, SKUs, product names)
      searchProducts(userText, function (products) {
        if (products.length) {
          var h = "Here's what I found in the catalog:" + linksHtml(products);
          h += '<div class="a1-chat-sep">Or reach a real person:</div>' + linksHtml([
            { label: 'Call ' + PHONE, url: 'tel:+1' + PHONE.replace(/-/g, '') }
          ]);
          bind(addMsg(h, 'bot'), null);
          emit('chatbot_fallback', { query: userText.slice(0, 80), product_results: products.length });
          return;
        }
        var useful = top.filter(function (t) { return t.s > 0.12; });
        var h = "I'm not sure about that one";
        if (useful.length) {
          h += ' \u2014 here are the closest topics:' + linksHtml(useful.map(function (t) {
            return { label: t.f.chip || t.f.questions[0], url: '#', faq: t.f.id };
          }));
        } else {
          h += '.';
        }
        h += '<div class="a1-chat-sep">Or reach a real person:</div>' + linksHtml([
          { label: 'Call ' + PHONE, url: 'tel:+1' + PHONE.replace(/-/g, '') },
          { label: 'Email us', url: 'mailto:' + EMAIL },
          { label: 'Repair page', url: '/pages/repairs' }
        ]);
        bind(addMsg(h, 'bot'), null);
        emit('chatbot_fallback', { query: userText.slice(0, 80) });
      });
    }


    function renderChips() {
      chipsBox.innerHTML = '';
      FAQ.slice(0, 4).forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = f.chip || f.questions[0];
        b.addEventListener('click', function () {
          chipsBox.innerHTML = '';
          addMsg(esc(f.chip || f.questions[0]), 'user');
          var typing = addMsg('<span class="a1-chat-typing"><span></span><span></span><span></span></span>', 'bot');
          setTimeout(function () { typing.remove(); answer(f, 1); }, TYPING_MS);
        });
        chipsBox.appendChild(b);
      });
    }

    function openPanel() {
      panelOpen = true;
      panel.hidden = false;
      launcher.setAttribute('aria-expanded', 'true');
      root.classList.add('a1chat-open');
      clearTimeout(roamTimer);
      hideBubble();
      if (state === 'roaming') goHome();
      if (!isMobile()) input.focus();
      if (!greeted) {
        greeted = true;
        addMsg("Hi! I'm Spinny. Ask me about repairs, returns, parts — or pick a topic below.", 'bot');
        renderChips();
      }
      emit('chatbot_open', {});
    }

    function closePanel() {
      panelOpen = false;
      panel.hidden = true;
      launcher.setAttribute('aria-expanded', 'false');
      root.classList.remove('a1chat-open');
      scheduleRoam();
    }

    /* ---------- events ---------- */
    launcher.addEventListener('click', function () { if (panelOpen) closePanel(); else openPanel(); });
    closeBtn.addEventListener('click', function () { closePanel(); launcher.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panelOpen) { closePanel(); launcher.focus(); }
    });
    dismissBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      ss(DISMISS_KEY, '1');
      clearTimeout(roamTimer); clearTimeout(bubbleTimer); seq++;
      root.style.display = 'none';
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (!v) return;
      input.value = '';
      chipsBox.innerHTML = '';
      respond(v.slice(0, 300));
    });
    ['pointerdown', 'keydown', 'scroll'].forEach(function (ev) {
      window.addEventListener(ev, function () { if (state === 'parked') scheduleRoam(); }, { passive: true });
    });
    if (APRIL_FOOLS && !REDUCED && !isMobile()) {
      var swatCool = 0;
      document.addEventListener('mousemove', function (e) {
        if (state !== 'parked' || panelOpen) return;
        var now = Date.now();
        if (now - swatCool < 4000) return;
        var r = mascot.getBoundingClientRect();
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        if (Math.hypot(e.clientX - cx, e.clientY - cy) < 110) {
          swatCool = now;
          mascot.style.setProperty('--a1-swat-dir', e.clientX < cx ? -1 : 1);
          mascotImg.classList.remove('a1chat-swat');
          void mascotImg.offsetWidth;
          mascotImg.classList.add('a1chat-swat');
          setTimeout(function () { mascotImg.classList.remove('a1chat-swat'); }, 600);
        }
      }, { passive: true });
    }
    window.addEventListener('resize', function () {
      if (state === 'parked') { mascot.style.transform = ''; pos = { x: 0, y: 0 }; }
    });

    function fallbackTags() {
      var have = {};
      var tagged = document.querySelectorAll('[data-chat-target]');
      for (var k = 0; k < tagged.length; k++) have[tagged[k].getAttribute('data-chat-target')] = 1;
      var hasAll = function (t, words) {
        for (var w = 0; w < words.length; w++) if (t.indexOf(words[w]) === -1) return false;
        return true;
      };
      var as = document.querySelectorAll('a, button');
      for (var i = 0; i < as.length; i++) {
        var a = as[i];
        if (a.hasAttribute('data-chat-target')) continue;
        var t = (' ' + (a.textContent || '').toLowerCase().replace(/\s+/g, ' ') + ' ');
        var href = a.getAttribute('href') || '';
        var key = null;
        if (!have['header-phone'] && href.indexOf('tel:') === 0 && a.closest('header')) key = 'header-phone';
        else if (!have['nav-catalog'] && (t.indexOf('catalog') !== -1) && (a.closest('header') || a.closest('nav'))) key = 'nav-catalog';
        else if (!have['repair-estimate-btn'] && t.indexOf('estimate') !== -1) key = 'repair-estimate-btn';
        else if (!have['fast-pack-btn'] && hasAll(t, ['fast', 'pack'])) key = 'fast-pack-btn';
        else if (!have['repair-order-form'] && hasAll(t, ['repair', 'order', 'form'])) key = 'repair-order-form';
        if (key) { a.setAttribute('data-chat-target', key); have[key] = 1; }
      }
    }

    /* ---------- boot ---------- */
    function boot(data) {
      FAQ = prepare(data);
      fallbackTags();
      setPose('idle');
      root.classList.add('a1chat-ready');
      scheduleRoam();
      clearTimeout(roamTimer);
      roamTimer = setTimeout(roam, FIRST_ROAM_MS); // first stroll comes early
      if (!REDUCED && !ss(NUDGE_KEY)) {
        setTimeout(function () {
          if (!panelOpen && state === 'parked' && !ss(DISMISS_KEY)) {
            mascot.classList.add('a1chat-wave');
            showBubble('Questions? Ask me!', 3400);
            setTimeout(function () { mascot.classList.remove('a1chat-wave'); }, 1600);
            ss(NUDGE_KEY, '1');
          }
        }, NUDGE_DELAY);
      }
      // arrived via a "Show me" link from another page
      if (location.hash.indexOf(HASH_PREFIX) === 0) {
        var key = decodeURIComponent(location.hash.slice(HASH_PREFIX.length));
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
        var note = '';
        FAQ.forEach(function (f) { if (f.point_to && f.point_to.target === key && !note) note = f.point_to.note; });
        setTimeout(function () { pointAt(key, note); }, 900);
      }
    }

    if (window.A1_CHAT_FAQ_DATA) boot(window.A1_CHAT_FAQ_DATA);
    else if (faqUrl && window.fetch) {
      fetch(faqUrl, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(boot)
        .catch(function () { boot([]); });
    } else boot([]);

    // exposed for QA in the console / theme preview
    window.A1Chat = { match: function (q) { return bestMatches(q, 3).map(function (t) { return [t.f.id, +t.s.toFixed(2)]; }); }, point: pointAt };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
